import { render, staticRenderFns } from "./UdefUserCardVertical.vue?vue&type=template&id=5be0d9ac&scoped=true&"
import script from "./UdefUserCardVertical.vue?vue&type=script&lang=js&"
export * from "./UdefUserCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./UdefUserCardVertical.vue?vue&type=style&index=0&id=5be0d9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0d9ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
